<!-- <app-slider ></app-slider>
<app-product-banner></app-product-banner>
<app-spacail-offer></app-spacail-offer>
<app-topselling-product></app-topselling-product> -->

<app-slider></app-slider>

<!-- Product Banner -->
<div lazyLoad (visible)="showBanner = true">
  <app-product-banner
    *ngIf="showBanner"
    class="fade-slide">
  </app-product-banner>
</div>

<!-- Special Offer: it has a large product grid and several API-backed sections.
     Create it only once the visitor reaches it. -->
<div lazyLoad (visible)="showSpecial = true">
  <app-spacail-offer
    *ngIf="showSpecial"
    class="fade-slide">
  </app-spacail-offer>
</div>

<!-- Top Selling -->
<div lazyLoad (visible)="showTopSelling = true">
  <app-topselling-product
    *ngIf="showTopSelling"
    class="fade-slide">
  </app-topselling-product>
</div>

